import React, {FC, JSX} from 'react';
import {HeadingType} from './TextTypes';


const H2: FC<HeadingType> = ({children, ...props}): JSX.Element => <h2
    className={'font-[600] text-neutral my-2'}
    {...props}
>{children}</h2>;

export default H2;